import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "./loginSlice";
import userSlice from "./userSlice"
import registerStudentSlice from "./registerStudentSlice";
import dashboardSlice from "./dashboardSlice";
import settingsSlice from "./settingSlice";
import courseSlice from "./courseSlice";
import paymentSlice from "./paymentSlice";
import notificationSlice from "./notificationSlice";
import chatSlice from "./chat"
import affiliateSlice from "./affiliateSlice"
import affiliateloginSlice from "./affiliateLoginSlice";
import registerAffiliateSlice from "./affiliateRegister";
import affiliatesettingsSlice from "./affiliateSettingSlice";
import supportChatSlice from "./supportChat"; // Add this import

export const store = configureStore({
    reducer: {
        login: loginSlice,
        user: userSlice,
        register: registerStudentSlice,
        notification: notificationSlice,
        chat: chatSlice,
        supportChat: supportChatSlice, // Add this line
        dashboard: dashboardSlice,
        settings: settingsSlice,
        courses: courseSlice,
        payments: paymentSlice,
        affiliate: affiliateSlice,
        affiliateLogin: affiliateloginSlice,
        affiliateRegister: registerAffiliateSlice,
        affiliateSettings: affiliatesettingsSlice, // Fixed duplicate key
    }
})